import { createAction } from '@reduxjs/toolkit';
export const ON_CONNECT = 'ON_CONNECT';
export const onConnectAction = createAction(ON_CONNECT);